// tool-add-remove-selection.ts
//
// Logic THUẦN (không UI) cho `avatar tool add` / `remove`:
//   - buildAddChoices: từ available (pack) + enabled (state) → list choice cho
//     checkbox. Cái đã cài hiện "(installed)" + pre-checked.
//   - buildRemoveChoices: từ enabled → list choice để gỡ.
//   - resolveNonInteractiveSelection: khi --all hoặc không TTY → trả selection
//     tự động (không hỏi).
//
// Tách khỏi command để test được mà không cần stub prompt UI.

export interface ToolChoice {
  name: string; // label hiển thị
  value: string; // tên tool
  checked: boolean; // pre-check trong checkbox
}

// ADD: list TẤT CẢ available; cái đang enabled → "(installed)" + pre-check.
export function buildAddChoices(available: string[], enabled: string[]): ToolChoice[] {
  const enabledSet = new Set(enabled);
  return available.map((name) => ({
    name: enabledSet.has(name) ? `${name} (installed)` : name,
    value: name,
    checked: enabledSet.has(name),
  }));
}

// REMOVE: chỉ list tool đang enabled (không pre-check — user chủ động chọn gỡ).
export function buildRemoveChoices(enabled: string[]): ToolChoice[] {
  return enabled.map((name) => ({ name, value: name, checked: false }));
}

// Khi --all hoặc non-TTY: chọn hết các giá trị candidate (không prompt).
// add → tất cả available; remove → tất cả enabled.
export function resolveNonInteractiveSelection(candidates: string[]): string[] {
  return [...candidates];
}
